<template>
  <div class="h-full">
    <!-- 1st Row -->
    <div class="d-flex align-center px-sm-2 px-2 py-2">
      <!-- Back Button -->
      <v-btn icon small class="me-2" @click=";(showWholeThread = false), $emit('close-email-view')">
        <v-icon size="28">
          {{ icons.mdiChevronLeft }}
        </v-icon>
      </v-btn>

      <!-- Subject -->
      <h1 class="font-weight-medium text-base me-2 text-truncate">
        {{ emailViewData.subject }}
      </h1>

      <v-spacer></v-spacer>
      <v-btn icon small class="me-2" @click="$emit('refreshEmail')">
        <v-icon size="21">
          {{ icons.mdiReload }}
        </v-icon>
      </v-btn>
    </div>

    <v-divider></v-divider>

    <!-- View earlier messages -->
    <p
      v-if="!showWholeThread && emailData && emailData.length > 1"
      class="text-base text--primary my-4 cursor-pointer text-center"
    >
      <span class="view-all-toggler" @click="showWholeThread = true"
        >View {{ emailData.length - 1 }} Earlier Message{{ emailData.length > 1 ? 's' : '' }}</span
      >
    </p>

    <!-- Replies -->
    <!-- Earlier Email Messages -->
    <div class="position-relative ma-sm-2 ma-2">
      <div v-if="!showWholeThread && emailData" class="email-replies-preview-container">
        <div
          v-for="(replyPreview, replyPreviewIndex) in emailData"
          :key="replyPreview"
          :style="threadStyles(replyPreviewIndex, emailData.length)"
          class="email-reply-preview bg-card"
        >
          <div class="message-content ma-5" v-html="replyPreview.body"></div>
        </div>
      </div>
      <template>
        <ReplyMessageCard
          v-for="(threadMail, index) in getEmailData"
          :key="index"
          :message="threadMail"
          class="mb-4"
          :prop-type="propType"
          @fetchRecord="$emit('refreshEmail')"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { computed, ref } from '@vue/composition-api'
import {
  mdiChevronLeft,
  mdiChevronRight,
  mdiTrashCanOutline,
  mdiEmailOutline,
  mdiFolderOutline,
  mdiLabelOutline,
  mdiArrowExpandVertical,
  mdiArrowCollapseVertical,
  mdiDotsVertical,
  mdiReload,
} from '@mdi/js'
import ReplyMessageCard from './ReplyMessageCard.vue'

export default {
  components: {
    // Local Components
    ReplyMessageCard,
  },
  props: {
    emailViewData: {
      type: Object,
      required: true,
    },
    emailData: {
      type: Array,
      default: () => [],
    },
    propType: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const showWholeThread = ref(false)

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    const getEmailData = computed(() => {
      if (showWholeThread.value) {
        return props.emailData
      }

      if (props.emailData.length > 1) {
        return [props.emailData[props.emailData.length - 1]]
      }

      return props.emailData
    })

    // Style for replies preview (UI)
    const threadStyles = computed(() => (replyIndex, total) => {
      const styles = {}
      const reverseIndex = total - replyIndex - 1

      styles.opacity = 1 - (reverseIndex + 1) * 0.25
      styles.width = `${100 - (reverseIndex + 1) * 5}%`

      return styles
    })

    return {
      perfectScrollbarSettings,
      getEmailData,
      threadStyles,
      showWholeThread,
      icons: {
        mdiChevronLeft,
        mdiChevronRight,
        mdiTrashCanOutline,
        mdiEmailOutline,
        mdiFolderOutline,
        mdiLabelOutline,
        mdiArrowExpandVertical,
        mdiArrowCollapseVertical,
        mdiDotsVertical,
        mdiReload,
      },
    }
  },
}
</script>

<style></style>
